export const INIT_FEATURES_STATE = {
  authWithSay: false,
  qAndA: false,
  messages: false,
  shareholders: false,
  voteSolicitation: false,
};
